import React from "react";
import { getDecryptedData, getDecryptedUserType } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import WelComeHeader from "./WelComeHeader";
import BookAppointment from "../BookAppointment/BookAppointment";
import AllAppointments from "../BookAppointment/AllAppointments";
import PatientAllergies from "./PatientAllergies";
import { Grid, Container, Box } from "@mui/material";
import PatientDocuments from "./PatientDocuments";
import PatientLabReports from "./PatientLabReports";
import DailyGoalData from "./DailyGoalData";
import SnapMeal from "./SnapMeal";
import DailyReportData from "./DailyReportData";
import PatientMembership from "../../PatientMembership/PatientMembership";

const PatientDashboard = () => {
  const LoginUserDetails = getDecryptedData();
  const LoginUserType = getDecryptedUserType();

  return (
    <Box>
    <WelComeHeader />
    <AllAppointments />
      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={12} md={4}>
          <PatientAllergies />
        </Grid>
        <Grid item xs={12} md={4}>
          <PatientLabReports />
        </Grid>
        <Grid item xs={12} md={4}>
          <PatientDocuments/>
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={12} md={4}>
          <DailyReportData />
        </Grid>
        <Grid item xs={12} md={4}>
          {/* <SnapMeal /> */}
          <PatientMembership/>
        </Grid>
        <Grid item xs={12} md={4}>
          <DailyGoalData />
        </Grid>
      </Grid>
        <BookAppointment />
    </Box>
  );
};

export default PatientDashboard;
